"use strict";
exports.__esModule = true;
exports.SvgFileAttachmentsSketch = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFileAttachmentsSketch = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("g", { fillRule: "nonzero" },
            react_1["default"].createElement("path", { fill: "#FDB300", d: "M4.355 1.595L9.98 1l5.625.595 4.355 5.846-9.98 11.621L0 7.441z" }),
            react_1["default"].createElement("path", { fill: "#EA6C00", d: "M4.042 7.44L9.98 19.061 0 7.44zM15.918 7.44L9.98 19.061 19.96 7.44z" }),
            react_1["default"].createElement("path", { fill: "#FDAD00", d: "M4.042 7.44h11.875L9.98 19.061z" }),
            react_1["default"].createElement("g", null,
                react_1["default"].createElement("path", { fill: "#FDD231", d: "M9.98 1l-5.625.595-.313 5.846zM9.98 1l5.625.595.312 5.846z" }),
                react_1["default"].createElement("path", { fill: "#FDAD00", d: "M19.96 7.441l-4.355-5.846.313 5.846zM0 7.441l4.355-5.846-.313 5.846z" }),
                react_1["default"].createElement("path", { fill: "#FEEEB7", d: "M9.98 1L4.042 7.441h11.875z" }))),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=FileAttachmentsSketch.js.map